import vademecum from "../../../services/policy/policy-medicine";
import i18n from "../../../i18n/index";

export default {
    data() {
        return {
            search: "",
            headers: [{
                    text: "Plu",
                    sortable: false,
                    value: "pluCode",
                },
                {
                    text: "Principio activo",
                    sortable: false,
                    value: "ActiveIngredient",
                },
                {
                    text: "Descripción principio activo",
                    sortable: false,
                    value: "descriptionActiveIngredient",
                },
                {
                    text: "Nombre comercial",
                    sortable: false,
                    value: "nameTrade",
                },
            ],
            itemsData: [],
            nroRows: 0,
        };
    },
    props: {},
    watch: {},
    mounted() {
        this.searchCity();
    },
    methods: {
        onRowClick(item) {
            this.$emit("row-click", item);
        },
        searchCity() {
            vademecum.getVademecumOrder().then((response) => {
                this.itemsData = response.data;
                this.nroRows = response.data.length;
            });
        },
        getLenght() {
            console.log(this.nroRows);
            return this.nroRows;
        },
        customFilter(items, search, filter) {
            search = search.toString().toLowerCase();
            return items.filter((row) => filter(row["ActiveIngredient"], search));
        },
    },
};